module.exports = __webpack_public_path__ + "static/logo_ysy_cloud_rvb-cdeb1458d4e4c85ddddad0c1a66ceda3.svg";